var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-button", staticStyle: { gap: "8px" } },
    [
      _c("ActivitiesStatusIconButton", {
        attrs: {
          canUpdate: _vm.activity.acl.can_be_updated,
          isActive: _vm.activity.status.done,
          disabled: !_vm.canUpdateStatusAsDone,
          pending: _vm.activity.status.pending,
          type: _vm.activity.type,
          size: _vm.sizeButton
        },
        on: {
          clicked: function($event) {
            return _vm.$emit("updateStatus")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.activity.acl.can_be_updated,
            arrow: false,
            content: _vm.$t.__(
              "common.labels.no_permissions_to_perform_this_action"
            )
          }
        },
        [
          _c(
            "ActivitiesRescheduleDatePicker",
            {
              attrs: { value: _vm.activity.date, placement: "bottom-start" },
              on: { "update:value": _vm.onUpdateDueDate }
            },
            [
              _c("CompassIconButton", {
                attrs: {
                  icon: "calendar-reschedule",
                  size: _vm.sizeButton,
                  "data-bot":
                    "activities-listing__action-reschedule-icon-button",
                  disabled: !_vm.canReschedule
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.activity.acl.can_be_updated,
            arrow: false,
            content: _vm.$t.__(
              "common.labels.no_permissions_to_perform_this_action"
            )
          }
        },
        [
          _vm.isActivityPage
            ? _c("CompassIconButton", {
                attrs: {
                  disabled: !_vm.activity.acl.can_be_updated,
                  icon: "edit",
                  size: _vm.sizeButton,
                  "data-bot": "activities-listing__action-edit-icon-button"
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.editActivity($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTooltip",
        {
          attrs: {
            disabled: _vm.activity.acl.can_be_deleted,
            arrow: false,
            content: _vm.$t.__(
              "common.labels.no_permissions_to_perform_this_action"
            )
          }
        },
        [
          _vm.isActivityPage
            ? _c("CompassIconButton", {
                attrs: {
                  disabled: !_vm.activity.acl.can_be_deleted,
                  icon: "bin",
                  size: _vm.sizeButton,
                  "data-bot": "activities-listing__action-delete-icon-button"
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.onDeleteActivity($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }